export const workTypesSelector = state => state.profile.workTypes;

export const avatarSelector = state => state.profile.avatar;

export const formDataSelector = state => state.profile.formData;
